module.exports = __webpack_public_path__ + "img/floor_bg.2de35ed6.jpg";